import styled from 'styled-components';
import { FlexBoxCol, FlexBoxRow } from '@r1-frontend/ui-react/components/layouts/flexBoxGrid';
import GridContainer from '@r1-frontend/ui-react/components/layouts/gridContainer';
import { COLORS } from '@r1-frontend/ui-react/assets/js/constants';
import { fonts } from '~/src/helpers/font';
import { breakPoints, styleWithBreakPoints, CSSPropWithBreakpoints, blockMargin } from '~/src/components/LandingBlock/styled';

export interface ILigalBlockStyles {
    [key: string]: CSSPropWithBreakpoints;
}

export const Wrapper = styled.div<{ [key: string]: string }>`
    position:relative;
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    color: ${COLORS.black};
    padding-top: 100px;
    background: ${p => p.background ? `url(${p.background}) no-repeat center / cover` : 'transparent'};
        
    @media (max-width: ${breakPoints.desktop}) {
        
        margin-left: 0;
        margin-right: 0;
    }
    
    @media (max-width: ${breakPoints.sDesktop}) {
        overflow: hidden;   
    }
    
    @media (max-width: ${breakPoints.mobile}) {
        margin-top: 50px;
    }

    ${p => blockMargin(p)}; 
    ${p => styleWithBreakPoints(p, 'Ligal')};
`;

export const StyledGrid = styled(GridContainer)`
    display: flex;
    max-width: 100%;
`;

export const Row = styled(FlexBoxRow)`
    width: 100%;
`;

export const LigalItem = styled(FlexBoxCol)<{ styleKey: string }>`
    position:relative;
    margin-bottom: 68px;
    max-width: 100%;

    &:first-child {
        padding-left: 70px;

        &:before {
            content: '';
            position:absolute;
            left: 0;
            top: -5px;
            width: 50px;
            height: 50px;
            background: url(${p => p.logo}) no-repeat;
            background-size: contain;
            
            @media (max-width: ${breakPoints.sDesktop}) {
                top: 5px;
            }
            
            @media (max-width: 467px) {
                top: 14px;
            }
        }
    }

    &:not(:only-child) {
        &:first-child {
            max-width: 41.66666666666667%;

            p {
                max-width: 322px;
                white-space: pre-wrap;
            }
        }

        &:nth-child(2) {
            max-width: 58.333333333333336%;
            margin-left: auto;
        }
    }

    @media (max-width: ${breakPoints.mobile}) {
        margin-bottom: 30px;

        &:not(:only-child) {
            &:first-child {
                max-width: 100%;
            }
            &:nth-child(2) {
                max-width: 100%;
                margin-left: auto;
            }
        }
    }

    ${p => styleWithBreakPoints(p, p.styleKey)}
`;

export const LigalText = styled.div<{ styleKey: string }>`
    font: ${fonts.XS};
    color: rgba(0,0,0,.5);
    
    @media (max-width: ${breakPoints.sDesktop}) {
        padding-top: 10px;
    }

    ${p => styleWithBreakPoints(p, p.styleKey)};
`;
